import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Libraries18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.75 8.32724V14.5C9.75 15.1904 9.19036 15.75 8.5 15.75H5.5C5.32222 15.75 5.15312 15.7129 5 15.646C4.84689 15.7129 4.67778 15.75 4.5 15.75H1.5C0.809644 15.75 0.25 15.1904 0.25 14.5V3.5C0.25 2.80964 0.809644 2.25 1.5 2.25H4.5C4.67778 2.25 4.84688 2.28711 5 2.35401C5.15312 2.28711 5.32222 2.25 5.5 2.25H8.5C9.03778 2.25 9.49623 2.5896 9.67262 3.06605L11.823 2.18368C12.4617 1.92161 13.1919 2.22691 13.4539 2.86559L17.6297 13.0422C17.8918 13.6808 17.5865 14.411 16.9478 14.6731L14.1724 15.812C13.5337 16.074 12.8035 15.7687 12.5414 15.1301L9.75 8.32724ZM13.8342 14.3294L9.84826 4.61535L12.1611 3.6663L16.1471 13.3803L13.8342 14.3294ZM1.75 3.75V14.25H4.25V3.75H1.75ZM8.25 14.25H5.75V3.75H8.25V14.25Z'
      fill='currentColor'
    />
  </Svg>
);

Libraries18.displayName = 'Libraries18';
export default Libraries18;
